import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import RmunitDashboard from '../RmunitDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function RmunitPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < RmunitDashboard />
    )

}